<!-- rts footer area start -->
<div class="rts-footer-area footer-one bg-footer-one">
    <div class="container bg-shape-f1">
        <!-- footer call to action area -->

        <!-- footer call to action area End -->
        <!-- rts footer area -->
        <div class="row pt--120 pt_sm--80 pb--80 pb_sm--40">
            <div class="col-xl-5 col-md-8 col-sm-12 col-12">
                <div class="footer-one-single-wized">
                    <div class="wized-title">
                        <h5 class="title">{{"FOOTER.LINKS" | translate}}</h5>
                        <img src="./images/footer/under-title.png" alt="ESRNM_footer">
                    </div>
                    <div class="quick-link-inner">
                        <ul class="links">
                            <li><a [routerLink]="'/home'"><i class="bi bi-arrow-right"></i> {{"MENU.HOME" |
                                    translate}}</a></li>
                            <li><a [routerLink]="'/about-us'"><i class="bi bi-arrow-right"></i>{{"MENU.ABOUT US" |
                                    translate}} </a></li>
                            <li><a [routerLink]="'/articles'"><i class="bi bi-arrow-right"></i>{{"MENU.POSTS" |
                                    translate}} </a></li>
                            <li><a [routerLink]="'/news'"><i class="bi bi-arrow-right"></i>{{"MENU.NEWS" | translate}}
                                </a></li>
                            <li><a [routerLink]="'/conferences'"><i class="bi bi-arrow-right"></i>{{"MENU.CONFERENCES"
                                    | translate}}</a>
                            </li>
                        </ul>
                        <ul class="links margin-left-70">
                            <li><a [routerLink]="'/radiology-schools'"><i class="bi bi-arrow-right"></i>
                                    {{"MENU.SCHOOL" | translate}}</a></li>
                            <li><a [routerLink]="'/branch'"><i class="bi bi-arrow-right"></i>{{"MENU.SUB ASSOCIATIONS"
                                    |
                                    translate}}</a></li>
                            <li><a [routerLink]="'/contact-us'"><i class="bi bi-arrow-right"></i>{{"MENU.CONTACT US" |
                                    translate}}</a></li>
                            <li><a [routerLink]="'/profile/memberships'"><i class="bi bi-arrow-right"></i>
                                    {{"MENU.MEMBERSHIP" | translate}}</a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>

            <!-- footer end area post -->
            <div class="col-xl-7 col-md-4 col-sm-12 col-12">
                <div class="footer-one-single-wized margin-left-65">
                    @for (setting of (settings|slice:0:1); track $index) {
                    <div class="wized-title">
                        <h5 class="title">{{setting?.name}}</h5>
                        <img src="./images/footer/under-title.png" alt="ESRNM_footer">
                    </div>
                    <div class="post-wrapper">
                        <!-- single post -->
                        <div class="single-footer-post mb--30">
                            <div class="post-right">
                                <div class="details" [innerHTML]="setting?.footerDescription | safeHtml">

                                </div>
                            </div>
                        </div>
                        <!-- single post End -->
                    </div>
                    }
                </div>
                <!-- footer end area post end-->
            </div>
            <!-- rts footer area End -->
        </div>
        <!-- copyright area start -->
        <div class="rts-copyright-area">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="text-center">
                            <p>{{"FOOTER.COPYRIGHT" |translate}}
                                <a class="link" target="_blank" href="https://jahezteam.com/">{{"FOOTER.JAHEZ" |
                                    translate}}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- copyright area end -->
    </div>
    <!-- rts footer area end -->